export const SHIFT_PRESETS = {
  SET_SHIFT_PRESETS: 'SET_SHIFT_PRESETS',
  SET_SHIFT_PRESETS_LOADING: 'SET_SHIFT_PRESETS_LOADING',
  ADD_SHIFT_PRESET: 'ADD_SHIFT_PRESET',
  UPDATE_SHIFT_PRESET: 'UPDATE_SHIFT_PRESET',
  REMOVE_SHIFT_PRESET: 'REMOVE_SHIFT_PRESET'
}
